import React from 'react'
import OrdersContainer from 'containers/panel/admin/orders-container'

const OrdersPage = () => {
  return (
    <OrdersContainer/>
  )
}

export default OrdersPage